import React from "react";
import { Layout } from "../../layout/Layout.js";
import { AccountsTable } from "./AccountsTable.js";

/**
 * Shows the accounts list page.
 */
export const AccountsPage = () => {
  return (
    <Layout title="Kontod" containerWidth="fixed-wide-min">
      <h2>Kontod</h2>
      <AccountsTable />
    </Layout>
  );
};
